import { render } from "./AgentLeads.vue?vue&type=template&id=777da106&scoped=true"
import script from "./AgentLeads.vue?vue&type=script&lang=js"
export * from "./AgentLeads.vue?vue&type=script&lang=js"

import "./AgentLeads.vue?vue&type=style&index=0&id=777da106&lang=scss&scoped=true"
import "./AgentLeads.vue?vue&type=style&index=1&id=777da106&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777da106"]])

export default __exports__